import glassData from './glassData';

const data = glassData.reduce((result, { id, images = [] }) => {
  return Object.assign(result, {
    [id]: images.reduce(
      (inner, imageId) =>
        Object.assign(inner, {
          [imageId]: {
            original: require(`../src/images/objects/${id}/${imageId}-original.jpg`),
            900: require(`../src/images/objects/${id}/${imageId}-900.jpg`),
            700: require(`../src/images/objects/${id}/${imageId}-700.jpg`),
            500: require(`../src/images/objects/${id}/${imageId}-500.jpg`),
            450: require(`../src/images/objects/${id}/${imageId}-450.jpg`),
            350: require(`../src/images/objects/${id}/${imageId}-350.jpg`),
            250: require(`../src/images/objects/${id}/${imageId}-250.jpg`),
            160: require(`../src/images/objects/${id}/${imageId}-160.jpg`),
            80: require(`../src/images/objects/${id}/${imageId}-80.jpg`),
            '80-blur': require(`../src/images/objects/${id}/${imageId}-80-blur.jpg`),
          },
        }),
      {}
    ),
  });
}, {});

export default data;



// WEBPACK FOOTER //
// ./data/glassImages.js